document.querySelectorAll('.product[data-product-id]').forEach(function(productEl) {
    var variantsData = productEl.dataset.variants;
    if (!variantsData) return;
    var variants = JSON.parse(variantsData);

    function compareArrays(longerArray, shorterArray) {
        for (var i = 0; i < shorterArray.length; i++) {
            if (shorterArray[i] !== longerArray[i]) return false;
        }
        return true;
    }

    function updateSelectedVariant() {
        var optionValues = Array.from(
            productEl.querySelectorAll('.option-value:not(.cart_attr).active')
        ).map(function(el) { return el.textContent.trim(); });
        var variant = variants.find(function(v) { return compareArrays(v.options, optionValues); });
        if (!variant) return;

        productEl.querySelectorAll('[data-add-variant]').forEach(function(el) {
            el.setAttribute('data-add-variant', variant.id);
        });
        productEl.querySelectorAll('[variant-price]').forEach(function(el) {
            el.classList.remove('active');
        });
        var priceEl = productEl.querySelector('[variant-price="' + variant.id + '"]');
        if (priceEl) priceEl.classList.add('active');

        var addToCart = productEl.querySelector('.add-to-cart-wrapper');
        if (addToCart) {
            if (variant.available) {
                addToCart.classList.remove('sold-out');
            } else {
                addToCart.classList.add('sold-out');
            }
        }
    }

    productEl.querySelectorAll('.option-value').forEach(function(optionValue) {
        optionValue.addEventListener('click', function(e) {
            e.target.parentNode.querySelectorAll('.option-value').forEach(function(ov) {
                ov.classList.remove('active');
            });
            optionValue.classList.add('active');
            updateSelectedVariant();
        });
    });

    productEl.querySelectorAll('[data-option-type="Color"] .option-value, [data-option-type="Type"] .option-value').forEach(function(optionValue) {
        optionValue.addEventListener('click', function(e) {
            if (window.changeMaterialColor) window.changeMaterialColor(e.target.textContent.indexOf('Gold') > -1 ? 0xc9ba59 : 0xffffff);
            if (window.toggleEnvMap) window.toggleEnvMap(e.target.textContent.indexOf('Gold') > -1);
        });
    });

    productEl.querySelectorAll('[data-option-type="Finish"] .option-value, [data-option-type="Type"] .option-value').forEach(function(optionValue) {
        optionValue.addEventListener('click', function(e) {
            if (window.changeReflectiveness) window.changeReflectiveness(
                e.target.textContent.indexOf('Satin') > -1 || e.target.textContent.indexOf('Matte') > -1
            );
        });
    });

    productEl.querySelectorAll('.product-info-dropdown-title').forEach(function(title) {
        title.addEventListener('click', function(e) {
            e.target.parentNode.classList.toggle('open');
        });
    });

    productEl.querySelectorAll('.quantity-button').forEach(function(button) {
        var parent = button.parentNode.parentNode;
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var increment = parseInt(e.target.getAttribute('data-increment'));
            var input = e.target.parentNode.querySelector('.quantity-value');
            var currentValue = parseInt(input.value);
            if (currentValue + increment > 0) {
                input.value = currentValue + increment;
            }
            var addVariantBtn = parent.querySelector('[data-add-variant]');
            if (addVariantBtn) addVariantBtn.setAttribute('data-add-q', input.value);
        });
    });

    productEl.querySelectorAll('.option-value').forEach(function(optionValue) {
        optionValue.addEventListener('click', function(e) {
            var productDetail = productEl.querySelector('.product-detail');
            if (productDetail && window.scrollY < productDetail.offsetTop) {
                window.scrollTo({ top: productDetail.offsetTop, behavior: 'smooth' });
            }
        });
    });

    updateSelectedVariant();
});
